import Logo from '@/assets/gearbelt-light.svg';

export default function IMSPage() {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-2 p-4 text-center">
      <img src={Logo} alt="Gearbelt Logo" className="h-6" />
      <p className="text-default-text text-sm">This app is no longer active, please contact your administrator for guidance where to submit your forms.</p>
    </div>
  );
}
